import type { ISceneManager, IScene } from "./types";

type SceneFactory = () => IScene;

/**
 * Svelte-based scene switching. Replaces URL routing.
 * Games have scenes, not URLs (per FLME §2).
 */
export class SceneManager implements ISceneManager {
  private factories = new Map<string, SceneFactory>();
  private current: { id: string; scene: IScene } | null = null;

  constructor(private readonly container: HTMLElement) {}

  register(id: string, factory: SceneFactory): void {
    this.factories.set(id, factory);
  }

  async changeScene(id: string, props?: Record<string, unknown>): Promise<void> {
    const factory = this.factories.get(id);
    if (!factory) throw new Error(`Unknown scene: ${id}`);

    if (this.current) {
      this.current.scene.unmount();
    }

    const scene = factory();
    scene.mount(this.container, props);
    this.current = { id, scene };
  }

  currentSceneId(): string | null {
    return this.current?.id ?? null;
  }
}
